/**
 * Created by bholmes on 4/14/2016.
 */

import { ImmutableStore } from 'fluxible-immutable-utils';
import Actions from '../constants/Actions';

class LoginStore extends ImmutableStore {
  static storeName = 'LoginStore';

  static handlers = {
    [Actions.EMPLOYEES_LOADED]: 'handleEmployeesLoaded',
    [Actions.EMPLOYEES_CONFLICTS_LOADED]: 'handleEmployeeConflictsLoaded',
    [Actions.EMPLOYEE_SEARCH_VALUE_CHANGED]: 'handleEmployeeSearchValueChanged',
    [Actions.BRANCHES_LOADED]: 'handleBranchesLoaded',
    [Actions.NEW_EMPLOYEE_SELECTED]: 'editEmployee',
    [Actions.EDIT_EMPLOYEE_SELECTED]: 'editEmployee',
    [Actions.EMPLOYEE_SELECTED]: 'employeeSelected',
    [Actions.EMPLOYEE_DESELECTED]: 'employeeDeselected',
    [Actions.EMPLOYEE_UPDATE_SUCCESSFUL]: 'employeeSaved',
    [Actions.EMPLOYEE_UPDATE_CANCELED]: 'employeeEditCanceled',
    [Actions.EMPLOYEE_UPDATE_ERROR]: 'employeeErrorsReceived',
    [Actions.EMPLOYEE_SEARCH_STARTED]: 'processingStarted',
    [Actions.BRANCH_SEARCH_STARTED]: 'processingStarted',
    [Actions.EMPLOYEE_UPDATE_STARTED]: 'processingStarted',
    [Actions.EMPLOYEE_SEARCH_FAILED]: 'processingCompleted',
    [Actions.EMPLOYEE_UPDATE_FAILED]: 'processingCompleted',
    [Actions.EMPLOYEE_LOGIN_STARTED]: 'processingStarted',
    [Actions.EMPLOYEE_LOGGED_IN]: 'processingCompleted',
    [Actions.ENABLE_EDIT]: 'handleEnableEdit'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.setState({
      employees: [],
      employeeConflicts: [],
      branches: [],
      selectedScreen: 'search',
      employeeSearchValue: '',
      employeeErrors: [],
      processing: false,
      allowEdit: true
    });
  }

  handleEnableEdit(allowEdit) {
    this.mergeState({
      allowEdit
    })
  }

  processingStarted() {
    this.mergeState({
      processing: true
    });
  }

  processingCompleted() {
    this.mergeState({
      processing: false
    });
  }

  handleEmployeesLoaded(employees = []) {
    this.mergeState({
      employees,
      processing: false
    });
  }

  handleEmployeeConflictsLoaded(conflicts) {
    const {email, id} = conflicts;
    const employeeConflicts = [];

    if(email){
      employeeConflicts.push(email);
    }
    if(id){
      employeeConflicts.push(id);
    }

    this.mergeState({
      employeeConflicts,
      processing: false
    });
  }

  handleBranchesLoaded(branches = []) {
    this.mergeState({
      branches,
      processing: false
    });
  }

  handleEmployeeSearchValueChanged(employeeSearchValue) {
    this.mergeState({
      employeeSearchValue
    });
  }

  employeeErrorsReceived(employeeErrors = []) {
    this.mergeState({
      employeeErrors
    });
  }

  getEmployees() {
    const items = this.get('employees');

    return items ? items.toJS() : [];
  }

  getBranches() {
    const items = this.get('branches');

    return items ? items.toJS() : [];
  }

  getSelectedScreen() {
    return this.get('selectedScreen');
  }

  getEmployeeConflicts() {
    const items = this.get('employeeConflicts');
    return items ? items.toJS() : [];
  }

  editEmployee(selectedEmployee) {
    const newState = {
      selectedScreen: 'edit',
      selectedEmployee,
      branches: [],
      employeeErrors: [],
      employeeConflicts: []
    };

    if (!selectedEmployee) {
      newState.selectedEmployee = null;
    }

    this.mergeState(newState);
  }

  employeeEditCanceled() {
    this.mergeState({
      selectedScreen: 'login',
      branches: [],
      employeeErrors: [],
      employeeConflicts: []
    });
  }

  employeeSaved(selectedEmployee) {
    this.mergeState({
      selectedEmployee,
      selectedScreen: 'login',
      branches: [],
      employeeErrors: [],
      processing: false,
      employeeConflicts: []
    });
  }

  employeeSelected(selectedEmployee) {
    const newState = {
      selectedScreen: 'login',
      selectedEmployee
    };

    this.mergeState(newState);
  }

  employeeDeselected() {
    this.mergeState({
      selectedScreen: 'search',
      selectedEmployee: null,
      employees: []
    });
  }

  getEmployeeSearchValue() {
    return this.get('employeeSearchValue');
  }

  getSelectedEmployee() {
    const employee = this.get('selectedEmployee');

    return employee ? employee.toJS() : null;
  }

  getEmployeeErrors() {
    return this.get('employeeErrors').toJS();
  }

  isProcessing() {
    return this.get('processing') || false;
  }

  canEdit() {
    return this.get('allowEdit');
  }
}

export default LoginStore;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/stores/LoginStore.js
 **/